import { render } from "./mainpage.vue?vue&type=template&id=5deb7a68&scoped=true"
import script from "./mainpage.vue?vue&type=script&lang=js"
export * from "./mainpage.vue?vue&type=script&lang=js"

import "./mainpage.vue?vue&type=style&index=0&id=5deb7a68&scoped=true&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5deb7a68"]])

export default __exports__